module.exports = __webpack_public_path__ + "static/Dark-Yellow-8668a4476603fde8062eb7e9529ca100.png";